import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { format } from 'date-fns';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../../redux/actions/loadingActions';
import GraphQL from '../../../GraphQL';
import { studentListByFilter } from '../../../shared/queries/Student';
import { classListActivesByFunc } from '../../../shared/queries/SchoolClass';
import { itemsTabletActiveListByLevelOnlyFormItems } from '../../../shared/queries/ItemsTablet';
import ReportParameters from '../index';
import SmartCard from '../../../shared/components/SmartCard';
import { communicationFindByIdTitle } from '../../../shared/queries/Communication';
import {
  REPORT_PARAMETERS,
  REPORT_TYPES,
  YEAR,
} from '../../../shared/utils/constants';
import { generateReport, openReport } from '../../../shared/utils/smartutils';
import {
  contractListId,
  responsibleStudentRelationListByFinantialContact,
  responsibleFinancialContact,
} from '../../../shared/queries/Contract';
import { subjectListAllIdName } from '../../../shared/queries/Subject';
import { courseListByFilter } from '../../../shared/queries/Course';
import { listAllEmployees } from '../../../shared/queries/Employee';

const ReportParametersFormHandler = (props) => {
  const { t, history, dispatch, match } = props;
  const all = {
    value: 999999999,
    label: t('general.placeholders.all'),
  };
  const [formOn, setFormOn] = useState(false);
  const [students, setStudents] = useState([]);
  const [classes, setClasses] = useState([]);
  const [surveys, setSurveys] = useState([]);
  const [items, setItems] = useState([]);
  const [contracts, setContracts] = useState([]);
  const [responsibleFinancial, setResponsibleFinancial] = useState([]);
  const [allResponsibleFinancial, setAllResponsibleFinancial] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [allCourse, setAllCourse] = useState([]);
  const [allSteps, setAllSteps] = useState([all]);
  const [allEmployees, setAllEmployees] = useState([all]);
  const years = [
    { value: YEAR['2019'], label: YEAR['2019'] },
    { value: YEAR['2020'], label: YEAR['2020'] },
    { value: YEAR['2021'], label: YEAR['2021'] },
    { value: YEAR['2022'], label: YEAR['2022'] },
    { value: YEAR['2023'], label: YEAR['2023'] },
    { value: YEAR['2024'], label: YEAR['2024'] },
  ];

  function backClickHandler() {
    history.push('/minime/relatorio');
  }

  function showLoading() {
    dispatch(changeLoadingTrue());
  }

  function hideLoading() {
    dispatch(changeLoadingFalse());
  }

  function loadStudents(filter) {
    let studentFilter;
    if (filter) {
      studentFilter = { ...filter };
    } else {
      studentFilter = {
        id: 0,
        classes: [],
        responsibles: [],
        menus: [],
        onlyActive: true,
      };
    }
    showLoading();
    const query = studentListByFilter(studentFilter);
    GraphQL(query, {})
      .then((res) => {
        if (res.studentListByFilter) {
          res.studentListByFilter = res.studentListByFilter.map((item) => ({
            ...item,
            value: item.id,
            label: item.fullName,
          }));
          const updateStudents = [all, ...res.studentListByFilter];
          setStudents(updateStudents);
          hideLoading();
        }
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  }

  const listClasses = () => {
    const query = classListActivesByFunc();
    showLoading();
    GraphQL(query, {})
      .then((res) => {
        res.classListActivesByFunc = res.classListActivesByFunc.map((item) => ({
          ...item,
          label: item.name,
          value: item.id,
        }));
        const updateClasses = [all, ...res.classListActivesByFunc];
        setClasses(updateClasses);
        hideLoading();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const listSurveys = () => {
    const query = communicationFindByIdTitle();
    showLoading();
    GraphQL(query, {})
      .then((res) => {
        res.communicationListByFilter = res.communicationListByFilter.map(
          (item) => ({
            ...item,
            label: item.title,
            value: item.id,
          })
        );
        setSurveys(res.communicationListByFilter);
        hideLoading();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const listItems = () => {
    const query = itemsTabletActiveListByLevelOnlyFormItems();
    showLoading();
    GraphQL(query, {})
      .then((res) => {
        res.itemsTabletActiveListByLevelOnlyFormItems =
          res.itemsTabletActiveListByLevelOnlyFormItems.map((item) => ({
            ...item,
            label: item.name,
            value: item.id,
          }));
        setItems(res.itemsTabletActiveListByLevelOnlyFormItems);
        hideLoading();
      })
      .catch((error) => {
        hideLoading();
        console.error(error);
      });
  };

  const listSubjects = () => {
    const query = subjectListAllIdName();
    GraphQL(query, {}).then((res) => {
      hideLoading();
      res.subjectListAll = res.subjectListAll.map((item) => ({
        ...item,
        value: item.id,
        label: item.name,
      }));
      const updateSubjects = [all, ...res.subjectListAll];
      setSubjects(updateSubjects);
    });
  };

  const loadAllCourse = () => {
    const filter = { id: 0 };
    const query = courseListByFilter(filter);
    GraphQL(query, {}).then((res) => {
      hideLoading();
      res.courseListByFilter = res.courseListByFilter.map((course) => ({
        ...course,
        value: course.id,
        label: course.name,
      }));
      const updateCourse = [all, ...res.courseListByFilter];
      setAllCourse(updateCourse);
    });
  };

  const loadAllSteps = (value) => {
    const filter = { id: value };
    const query = courseListByFilter(filter);
    GraphQL(query, {})
      .then((res) => {
        let stepsCourse = res.courseListByFilter[0];
        stepsCourse = stepsCourse.steps.map((steps) => ({
          ...steps,
          value: steps.id,
          label: steps.fullName,
        }));
        const updateStepsCourse = [all, ...stepsCourse];
        setAllSteps(updateStepsCourse);
        hideLoading();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const loedAllEmployees = () => {
    const query = listAllEmployees();
    GraphQL(query, {}).then((res) => {
      res.employeeListByFilter = res.employeeListByFilter.map((employees) => ({
        ...employees,
        value: employees.id,
        label: employees.name,
      }));
      const updateSubjects = [all, ...res.employeeListByFilter];
      setAllEmployees(updateSubjects);
      hideLoading();
    });
  };

  const showReport = async (formData) => {
    showLoading();
    generateReport(formData)
      .then(async (res) => {
        openReport(res.data);
        hideLoading();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('report.error-generate')
        );
      });
  };

  const formatType = (value) => {
    let type;
    switch (value) {
      case 'S':
        type = 1;
        break;
      case 'A':
        type = 2;
        break;
      case 'R':
        type = 3;
        break;
      default:
        type = 0;
    }
    return type;
  };

  const handleSubmit = async (values) => {
    if (
      match.params.type === REPORT_TYPES.RELA_TROCAS ||
      match.params.type === REPORT_TYPES.RELA_SONECA ||
      match.params.type === REPORT_TYPES.RELA_IMCIDA ||
      match.params.type === REPORT_TYPES.RELA_ALIMEN ||
      match.params.type === REPORT_TYPES.RELA_MEDICA ||
      match.params.type === REPORT_TYPES.RELA_SMRTGO
    ) {
      const formData = new FormData();
      formData.append(REPORT_PARAMETERS.REPORTTYPE, match.params.type);
      formData.append(REPORT_PARAMETERS.pCO90ALUN, values.students.value);
      formData.append(
        'dtIni',
        format(new Date(values.initialDate), 'yyyy-MM-dd')
      );
      formData.append(
        'dtFim',
        format(new Date(values.finalDate), 'yyyy-MM-dd')
      );
      formData.append(REPORT_PARAMETERS.pCO00TURM, values.classesnames.value);
      showReport(formData);
    }
    if (match.params.type === REPORT_TYPES.RELA_PREALU) {
      const formData = new FormData();
      formData.append(REPORT_PARAMETERS.REPORTTYPE, values.type);
      formData.append(REPORT_PARAMETERS.pCO90ALUN, values.students.value);
      formData.append(
        'dtIni',
        format(new Date(values.initialDate), 'yyyy-MM-dd')
      );
      formData.append(
        'dtFim',
        format(new Date(values.finalDate), 'yyyy-MM-dd')
      );
      formData.append(REPORT_PARAMETERS.pCO00TURM, values.classesnames.value);
      showReport(formData);
    }
    if (
      match.params.type === REPORT_TYPES.RELA_CRESCI ||
      match.params.type === REPORT_TYPES.RELA_ALTIDA ||
      match.params.type === REPORT_TYPES.RELA_PESIDA ||
      match.params.type === REPORT_TYPES.RELA_ALIMFI
    ) {
      const formData = new FormData();
      formData.append(REPORT_PARAMETERS.REPORTTYPE, match.params.type);
      formData.append(REPORT_PARAMETERS.pCO90ALUN, values.students.value);
      formData.append(REPORT_PARAMETERS.pCO00TURM, values.classesnames.value);
      showReport(formData);
    }

    if (
      match.params.type === REPORT_TYPES.RELA_DIARIO ||
      match.params.type === REPORT_TYPES.RELA_ANALIP ||
      match.params.type === REPORT_TYPES.RELA_DIARES
    ) {
      const formData = new FormData();
      formData.append(REPORT_PARAMETERS.REPORTTYPE, match.params.type);
      formData.append(REPORT_PARAMETERS.pCO90ALUN, values.students.value);
      formData.append(REPORT_PARAMETERS.pCO00TURM, values.classesnames.value);
      formData.append('dtIni', format(new Date(values.date), 'yyyy-MM-dd'));
      showReport(formData);
    }

    if (match.params.type === REPORT_TYPES.RELA_ALUTUR) {
      const formData = new FormData();
      formData.append(REPORT_PARAMETERS.REPORTTYPE, match.params.type);
      formData.append(REPORT_PARAMETERS.pCO00TURM, values.classesnames.value);

      formData.append(
        'dtIni',
        format(new Date(values.initialDate), 'yyyy-MM-dd')
      );
      formData.append(
        'dtFim',
        format(new Date(values.finalDate), 'yyyy-MM-dd')
      );
      showReport(formData);
    }

    if (
      match.params.type === REPORT_TYPES.RELA_ALURES ||
      match.params.type === REPORT_TYPES.RELA_ATEFRE
    ) {
      const formData = new FormData();
      formData.append(REPORT_PARAMETERS.REPORTTYPE, match.params.type);
      formData.append(REPORT_PARAMETERS.pCO90ALUN, values.students.value);
      formData.append(REPORT_PARAMETERS.pCO00TURM, values.classesnames.value);
      showReport(formData);
    }

    if (match.params.type === REPORT_TYPES.RELA_ANIVER) {
      const formData = new FormData();
      formData.append(REPORT_PARAMETERS.REPORTTYPE, match.params.type);
      formData.append('dtIni', format(new Date(values.month), 'yyyy-MM-dd'));
      formData.append('tipo', formatType(values.availableTo));
      showReport(formData);
    }

    if (match.params.type === REPORT_TYPES.RELA_COPEAU) {
      const formData = new FormData();
      formData.append(REPORT_PARAMETERS.REPORTTYPE, match.params.type);
      formData.append(REPORT_PARAMETERS.pCO00MENS, values.survey.id);
      showReport(formData);
    }

    if (match.params.type === REPORT_TYPES.RELA_COVIDF) {
      const formData = new FormData();
      formData.append(REPORT_PARAMETERS.REPORTTYPE, match.params.type);
      formData.append(REPORT_PARAMETERS.pCO90ALUN, values.students.value);
      formData.append(REPORT_PARAMETERS.pCO00TURM, values.classesnames.value);
      formData.append(
        'dtIni',
        format(new Date(values.initialDate), 'yyyy-MM-dd')
      );
      formData.append(
        'dtFim',
        format(new Date(values.finalDate), 'yyyy-MM-dd')
      );
      formData.append(REPORT_PARAMETERS.pCO00ITEM, values.item.value);
      showReport(formData);
    }

    if (match.params.type === REPORT_TYPES.RELA_QUDE) {
      const formData = new FormData();
      formData.append(REPORT_PARAMETERS.REPORTTYPE, match.params.type);
      formData.append(REPORT_PARAMETERS.pISAPP, 0);
      formData.append(REPORT_PARAMETERS.pCO90ALUN, values.students.value);
      formData.append(
        REPORT_PARAMETERS.pCO90RESP,
        values.responsibleFinancial.value
      );
      formData.append(REPORT_PARAMETERS.pANO, values.year.value);
      showReport(formData);
    }

    if (match.params.type === REPORT_TYPES.RELA_SPAYR) {
      const formData = new FormData();
      formData.append(REPORT_PARAMETERS.REPORTTYPE, match.params.type);
      formData.append(
        'dtIni',
        format(new Date(values.initialDate), 'yyyy-MM-dd')
      );
      formData.append(
        'dtFim',
        format(new Date(values.finalDate), 'yyyy-MM-dd')
      );
      showReport(formData);
    }

    if (match.params.type === REPORT_TYPES.RELA_CONTMOV) {
      const formData = new FormData();
      formData.append(REPORT_PARAMETERS.REPORTTYPE, match.params.type);
      formData.append(REPORT_PARAMETERS.pCO00CONT, values.contract.value);
      formData.append(REPORT_PARAMETERS.pCO90ALUN, values.students.value);
      formData.append(REPORT_PARAMETERS.pCO90RESP, values.responsibles.value);
      showReport(formData);
    }

    if (match.params.type === REPORT_TYPES.RELA_TARE) {
      const formData = new FormData();
      formData.append(REPORT_PARAMETERS.REPORTTYPE, match.params.type);
      formData.append(
        'dtIni',
        format(new Date(values.initialDate), 'yyyy-MM-dd')
      );
      formData.append(
        'dtFim',
        format(new Date(values.finalDate), 'yyyy-MM-dd')
      );
      formData.append(REPORT_PARAMETERS.pCO90ALUN, values.students.value);
      formData.append(REPORT_PARAMETERS.pCO00TURM, values.classesnames.value);
      formData.append(REPORT_PARAMETERS.pCO00MATR, values.subjects.value);
      showReport(formData);
    }

    if (match.params.type === REPORT_TYPES.RELA_CLASS_DIARY) {
      const formData = new FormData();
      formData.append(REPORT_PARAMETERS.REPORTTYPE, match.params.type);
      formData.append(
        REPORT_PARAMETERS.pDATAINIC,
        format(new Date(values.initialDate), 'yyyy-MM-dd')
      );
      formData.append(
        REPORT_PARAMETERS.pDATAFINA,
        format(new Date(values.finalDate), 'yyyy-MM-dd')
      );
      formData.append(REPORT_PARAMETERS.pCO00TURM, values.classesnames.value);
      formData.append(REPORT_PARAMETERS.pCO00MATR, values.subjects.value);
      formData.append(REPORT_PARAMETERS.pCO00CURS, values.coursenames.value);
      formData.append(REPORT_PARAMETERS.pCO01CURS, values.allSteps.value);
      formData.append(REPORT_PARAMETERS.pCO00FUNC, values.allEmployees.value);
      showReport(formData);
    }

    if (match.params.type === REPORT_TYPES.RELA_STUDENT_AGREEMENT) {
      const formData = new FormData();
      formData.append(REPORT_PARAMETERS.REPORTTYPE, match.params.type);
      formData.append(REPORT_PARAMETERS.pCO00TURM, values.classesnames.value);
      formData.append(REPORT_PARAMETERS.pORIGIN, values.agreement.value);
      showReport(formData);
    }

    if (match.params.type === REPORT_TYPES.RELA_ALUNOS) {
      const formData = new FormData();
      formData.append(REPORT_PARAMETERS.REPORTTYPE, match.params.type);
      formData.append(REPORT_PARAMETERS.pCO00TURM, values.classesnames.value);
      showReport(formData);
    }

    if (match.params.type === REPORT_TYPES.RELA_CALEAN) {
      const formData = new FormData();
      formData.append(REPORT_PARAMETERS.REPORTTYPE, match.params.type);
      formData.append(
        REPORT_PARAMETERS.pDATAINIC,
        format(new Date(values.year), 'yyyy-MM-dd')
      );
      showReport(formData);
    }

    if (match.params.type === REPORT_TYPES.RELA_ACCOUNTS_RECEIVABLE) {
      const formData = new FormData();
      formData.append(REPORT_PARAMETERS.REPORTTYPE, match.params.type);
      formData.append(
        REPORT_PARAMETERS.pDATAINIC,
        format(new Date(values.initialDate), 'yyyy-MM-dd')
      );
      formData.append(
        REPORT_PARAMETERS.pDATAFINA,
        format(new Date(values.finalDate), 'yyyy-MM-dd')
      );
      formData.append(
        REPORT_PARAMETERS.pDATAPAGA,
        format(new Date(values.payday), 'yyyy-MM-dd')
      );
      showReport(formData);
    }
  };

  const loadResponsibleFinancial = (studentId) => {
    const query = responsibleStudentRelationListByFinantialContact(studentId);
    showLoading();
    GraphQL(query, {})
      .then((res) => {
        hideLoading();
        res.responsibleStudentRelationListByFinantialContact =
          res.responsibleStudentRelationListByFinantialContact.map((item) => ({
            ...item,
            id: item.responsible.id,
            value: item.responsible.id,
            label: t(`${item.responsible.fullName}`),
          }));
        setResponsibleFinancial(
          res.responsibleStudentRelationListByFinantialContact
        );
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const loadAllFinancialResponsibles = () => {
    const query = responsibleFinancialContact();
    GraphQL(query, {})
      .then((res) => {
        hideLoading();
        res.responsibleStudentRelationListByFinantialContact =
          res.responsibleStudentRelationListByFinantialContact.map((item) => ({
            ...item,
            id: item.responsible.id,
            value: item.responsible.id,
            label: t(`${item.responsible.fullName}`),
          }));
        const updateResponsibles = [
          all,
          ...res.responsibleStudentRelationListByFinantialContact,
        ];
        setAllResponsibleFinancial(updateResponsibles);
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const loadContracts = () => {
    const query = contractListId();
    showLoading();
    GraphQL(query, {}).then((res) => {
      hideLoading();
      const updateContracts = [all, ...res.contractListByFilter];
      setContracts(updateContracts);
    });
  };

  useEffect(() => {
    loadStudents();
    listClasses();
    listSurveys();
    listItems();
    loadContracts();
    listSubjects();
    loadAllFinancialResponsibles();
    loadAllCourse();
    loedAllEmployees();
    if (match.params.type) {
      setFormOn(true);
    }
  }, []);

  return (
    <SmartCard title={`${t('report.parameters.title')} - ${match.params.name}`}>
      {formOn ? (
        <ReportParameters
          onSubmit={handleSubmit}
          backHandler={backClickHandler}
          students={students}
          classes={classes}
          surveys={surveys}
          items={items}
          type={match.params.type}
          responsibleFinancial={responsibleFinancial}
          allResponsibleFinancial={allResponsibleFinancial}
          loadResponsibleFinancial={loadResponsibleFinancial}
          loadStudentsByFilter={loadStudents}
          years={years}
          contracts={contracts}
          subjects={subjects}
          allCourse={allCourse}
          loadAllSteps={loadAllSteps}
          allSteps={allSteps}
          allEmployees={allEmployees}
        />
      ) : null}
    </SmartCard>
  );
};

ReportParametersFormHandler.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(ReportParametersFormHandler)
);
